import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { MenuInCart } from "../../ducks/menu";
import { Footer } from "../organisms/Footer";
import { Header } from "../organisms/Header";

type Props = {
  showAppCouponHeader?: boolean;
  menusToReorder?: MenuInCart[] | null;
  requiredLogout?: boolean;
};

export const MainTemplate: React.FC<Props> = ({
  showAppCouponHeader,
  menusToReorder,
  requiredLogout,
}) => {
  return (
    <main>
      <Header
        showAppCouponHeader={showAppCouponHeader ?? false}
        menusToReorder={menusToReorder}
        requiredLogout={requiredLogout}
      />
      <OutletContainer>
        <Outlet />
      </OutletContainer>
      <Footer />
    </main>
  );
};

const OutletContainer = styled.div`
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 54px;
  min-width: 375px;
  min-height: calc(100vh - 54px - 98px);
`;
